import { useOticonLanguageRedirect } from "../../../../../utils/useOticonLanguageRedirect";

const OticonLanguageRedirect = ({ languageList }) => {
  useOticonLanguageRedirect(languageList.map(({ fields }) => fields.key.value));

  return null;
};

export default OticonLanguageRedirect;
